import React, { useState, useRef } from "react";
import RedoSubject from "./re_registration_sub/RedoSubject";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { submitReRegistrationService } from "../../services/ReRegistrationService";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setReRegistrationsReload } from "../../store/actions";
import DigitalSignatureComponent from "../common/DigitalSignatureComponent";
import { TextLink } from "../common/GlobalElements/Typography";
import { StandardButton } from "../common/GlobalElements/StandardButton";

function SchoolOfArtisans(props) {
  const { reRegSubject, setReadOnly, setStudentNewRegId, lateReg } = props;
  const [isSig, setIsSig] = useState("")
  const signaturePadRef = useRef(null);
  const fileInputRef = useRef(null);
  const [ipAddress, setIpAddress] = useState('');
  const [cDate,setCDate] = useState('')
  const [isCancel, setIsCancel] = useState(false)
  const [emptyFields, setEmptyFields] = useState(false)
  const [parentSubjectProgLength, setparentSubjectProgLength] = useState([]);
  const [parentSubjectRedoLength, setParentSubjectRedoLength] = useState([
    { subject: "" },
  ]);
  const [parentSubjectReWriteLength, setparentSubjectReWriteLength] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const isReReg = useSelector(state=>state.isReReg);
  const reload = useSelector(state => state.registrations.reload);
  
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  const handleCancel = () => {
    setIsCancel(true)
    setEmptyFields(true)
    setIsSig("")
    setChecked(false)
    setIpAddress('')
    setParentSubjectRedoLength([{subject : ""}])
    setparentSubjectProgLength([])
    setCDate('')
    
    setTimeout(() => {
      setIsCancel(false);
      setEmptyFields(false)
    }, 100);
  }
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subjectProgress_: parentSubjectProgLength,
      subjectRedo_: parentSubjectRedoLength,
      subjectReWrite_: parentSubjectReWriteLength,
      rereg_academy: props.registration.academy,
      rereg_id: props.registration.id,
      term_condn: checked,
      late_reg : lateReg,
      student_signature : isSig,
      ip: ipAddress,
      signature_date:parseInt(new Date(cDate).getTime()/1000)
    },
    validationSchema: Yup.object({
      student_signature : Yup.mixed().required('Signature is required'),
      term_condn: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const formData = new FormData();
      
      // Append all values from the form
      const appendFormData = (data) => {
        Object.keys(data).forEach(key => {
          const value = data[key];
          
          if (Array.isArray(value)) {
            // For array values, stringify the entire array
            formData.append(key, JSON.stringify(value));
          } else if (typeof value === 'object' && value !== null) {
            if (value instanceof File) {
              // Handle file objects
              formData.append(key, value);
            } else {
              // Stringify other objects
              formData.append(key, JSON.stringify(value));
            }
          } else {
            // Append primitive values directly
            formData.append(key, value);
          }
        });
      };
      appendFormData(values)
      submitReRegistrationService(formData).then((res) => {
        Swal.fire({
          icon: "success",
          title: "Successfully Submitted",
          text: "This does not confirm approval of your re-registration!!",
          timer: 3000,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then(function (result) {
          setLoading(true);
          setStudentNewRegId(res.data.studentNewRegId);
          setReadOnly(true);
          props.updateStatus();
          if(isReReg.isReReg===true){
            dispatch(setReRegistrationsReload(!reload));
            history.push("/reregStatus");
          }
        });
      });
    },
  });
  
  return (
    <>
    <form onSubmit={formik.handleSubmit}>
    <div className="card-body disabled">
    <div className="theme-form application-form">
    <div className="row">
      <div className="form-group col-sm-12 inputfield">
      <h5 className="textdanger heading-5"> Re-registering for Failed Modules:</h5>
      <label>
      
      <b>NOTE:</b> It is mandatory to re-register for EVERY module you have failed. Failure to do so will result in a delay in your academic progress. <br/><br/>
      
      <b>Modules you did not pass and must re-register for:</b>
      </label>
      <RedoSubject
      formik={formik}
      setParentSubjectRedoLength={setParentSubjectRedoLength}
      parentSubjectRedoLength={parentSubjectRedoLength}
      reRegSubject={reRegSubject}
      setDelivery_methode={()=>{}}
      handleDisableField={()=>{}}
      />
      <DigitalSignatureComponent isCancel={isCancel} formik={formik} fileInputRef={fileInputRef} signaturePadRef={signaturePadRef} setCDate={setCDate} setIpAddress={setIpAddress} cDate={cDate} ipAddress={ipAddress} setIsSig={setIsSig}/>
      </div>
      <div className="col-12 form-group inputfield">
      <div className="custom-control custom-checkbox text-left box-tm">
      <input
      className={
        "custom-control-input " +
        (formik.touched.term_condn && formik.errors.term_condn
          ? " is-invalid"
          : "")
        }
        type="checkbox"
        name="term_condn"
        onChange={(e) => handleCheck(e)}
        onBlur={formik.handleBlur}
        checked={checked}
        id="customCheck1"
        />
        
        <label
        className="custom-control-label textdanger"
        htmlFor="customCheck1"
        >
        I hereby confirm that I have read, understood and accepted
        all <TextLink href='https://aie.ac/page/1_Terms%2520and%2520Conditions' target="_blank">Terms and Conditions</TextLink> as set out in the application form that the above subject selections are correct, and understand
        that there may be changes made based on the academic outcome.
        </label>
        {formik.touched.term_condn && formik.errors.term_condn ? (
          <div className="invalid-feedback">
          {formik.errors.term_condn}
          </div>
        ) : null}
        </div>
        </div>
        </div>
        </div>
        <div className="Fmfooter">
        <StandardButton
          variant="primary"
          title="Submit"
          type="submit"
        disabled={loading}
        >
        {loading && <i className="fas fa-cog fa-spin"></i>} Submit
        </StandardButton>
        <StandardButton
          variant="danger"
          title="Cancel"
          type="button"
          className="ml-2"
        >
          Cancel
        </StandardButton>
        </div>
        </div>
        </form>
        </>
      );
    }
    export default SchoolOfArtisans;
    